import React from "react";
import { useForm } from "react-hook-form";

import { CadastroGrupoInterface } from "../../../../Interfaces/Geral/Grupos/GrupoInterfaces";
import { CadastrarGupoController } from "../../../../Controllers/Geral/Grupos/GruposController";

interface ModalInterface {
    updateList: () => void;
    setShow: (show: boolean) => void;
}

export default function ModalCadastrarGrupo(props: ModalInterface) {
    const { register, handleSubmit, formState, reset } = useForm();

    const onSubmit = (formData: CadastroGrupoInterface) => {
        CadastrarGupoController(formData).then((res) => {
            props.setShow(false);
            reset();
            props.updateList();
        });
    };

    return (
        <>
            <div className="text-center mb-10 mb-lg-20">
                <h2 className="font-weight-bold">Cadastro de Grupo</h2>
                <p className="text-muted font-weight-bold">
                    Entre com seu o nome e permissões do grupo
                </p>
            </div>
            <form
                className="form"
                id="kt_login_signin_form"
                onSubmit={handleSubmit(onSubmit)}
            >
                <div className="form-group border-bottom py-3 b-5">
                    <input
                        className={`form-control h-auto border-0 px-0 placeholder-dark-75 ${
                            formState.errors.dS_GRUPO && "is-invalid"
                        }`}
                        type="text"
                        placeholder="Nome do Grupo"
                        name="dS_GRUPO"
                        ref={register({
                            required: "Insira o nome do grupo",
                        })}
                        autoComplete="off"
                    />
                    <div className="invalid-feedback">
                        {formState.errors.dS_GRUPO
                            ? formState.errors.dS_GRUPO.message
                            : ""}
                    </div>
                </div>
                <div className="form-row mb-5">
                    <div className="col-6 d-flex flex-column align-itens-center justify-content-center">
                        <div className="text-center font-weight-bold">
                            Analisa Crédito:
                        </div>
                        <span
                            className="switch switch-outline switch-sm switch-icon switch-info d-flex justify-content-center"
                            data-toggle="tooltip"
                        >
                            <label>
                                <input
                                    id="fL_ANALISAR_CREDITO_STATUS"
                                    name="fL_ANALISAR_CREDITO"
                                    defaultChecked={false}
                                    ref={register()}
                                    type="checkbox"
                                />
                                <span></span>
                            </label>
                        </span>
                    </div>
                    <div className="col-6 d-flex flex-column align-itens-center justify-content-center">
                        <div className="text-center font-weight-bold">
                            Gerencia Produtos:
                        </div>
                        <span
                            className="switch switch-outline switch-sm switch-icon switch-warning d-flex justify-content-center"
                            data-toggle="tooltip"
                        >
                            <label>
                                <input
                                    id="fL_GERENCIAR_PRODUTOS_STATUS"
                                    name="fL_GERENCIAR_PRODUTOS"
                                    defaultChecked={false}
                                    ref={register()}
                                    type="checkbox"
                                />
                                <span></span>
                            </label>
                        </span>
                    </div>
                </div>
                <div className="d-flex flex-wrap justify-content-center align-items-center">
                    <button
                        type="submit"
                        id="kt_login_signin_submit"
                        className="btn btn-capys font-weight-bold px-9 py-4 my-2"
                    >
                        Cadastrar
                    </button>
                </div>
            </form>
        </>
    );
}
